import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  buildNineSegmentsTableInfo,
  type NineSegmentColumnKey,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { useHighlightCells } from '~/hooks/useHighlightCells'
import { useTamRatio } from '~/hooks/useTamRatio'
import { type RowInfo } from '~/utils'

import {
  dataDisplayTypeAtom,
  hiddenRowIdsAtom,
  nineSegmentHiddenColumnKeysAtom,
  nineSegmentSortValueAtom,
} from '../atoms'

import { useNineSegmentsBrandsData } from './useNineSegmentsBrandsData'

type NineSegmentsTableInfoStyles = {
  indicatorPad: string
}

export const useNineSegmentsTableInfo = (
  styles: NineSegmentsTableInfoStyles,
): RowInfo<NineSegmentColumnKey>[] => {
  const tamRatio = useTamRatio()
  const { t } = useTranslation()

  const dataDisplayType = useAtomValue(dataDisplayTypeAtom)
  const sortValue = useAtomValue(nineSegmentSortValueAtom)
  const hiddenRowIds = useAtomValue(hiddenRowIdsAtom)
  const hiddenColumnKeys = useAtomValue(nineSegmentHiddenColumnKeysAtom)

  const brandsData = useNineSegmentsBrandsData()

  const { addHighlightProps } = useHighlightCells('customer-analysis')

  return React.useMemo(
    () =>
      buildNineSegmentsTableInfo({
        addHighlightProps,
        brandsData,
        dataDisplayType,
        hiddenColumnKeys,
        hiddenRowIds,
        indicatorPadClassName: styles.indicatorPad,
        sortValue,
        t,
        tamRatio,
      }),
    [
      addHighlightProps,
      brandsData,
      dataDisplayType,
      hiddenColumnKeys,
      hiddenRowIds,
      sortValue,
      styles.indicatorPad,
      t,
      tamRatio,
    ],
  )
}
